export default __webpack_public_path__ + "static/media/jkr_logo_v2.ca11f7e7.png";